function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import CONSTANTS from './Constants';
import Label from './Label';
import './TextInput.css';

var TextInput = function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput(props) {
    _classCallCheck(this, TextInput);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChange = function (e) {
      if (typeof _this.props.onChange === 'function') {
        _this.props.onChange(e.target.value);
      }

      if (typeof _this.props.handleChange === 'function') {
        _this.props.handleChange(e.target.value);
      }
    };

    _this.handleKeyDown = function (e) {
      if (typeof _this.props.onKeyDown === 'function') {
        _this.props.onKeyDown(e);
      }

      if (typeof _this.props.handleKeyDown === 'function') {
        _this.props.handleKeyDown(e);
      }

      if (e.key === CONSTANTS.ENTER_KEY) {
        _this.handleEnter();
      }
    };

    _this.handleFocus = function () {
      if (typeof _this.props.onFocus === 'function') {
        _this.props.onFocus();
      }
    };

    _this.handleBlur = function () {
      if (typeof _this.props.onBlur === 'function') {
        _this.props.onBlur();
      }
    };

    _this.handleEnter = function () {
      if (typeof _this.props.onEnter === 'function') {
        _this.props.onEnter();
      }
    };

    _this.input = React.createRef();
    return _this;
  }

  TextInput.prototype.componentDidMount = function componentDidMount() {
    if (this.props.autoFocus) {
      this.input.current.focus();
    }
  };

  TextInput.prototype.getPadding = function getPadding() {
    if (this.props.padding) {
      return this.props.padding;
    }
    return '';
  };

  TextInput.prototype.focus = function focus() {
    this.input.current.focus();
  };

  TextInput.prototype.render = function render() {
    return React.createElement(
      'div',
      { className: 'Field Input TextInput', style: { width: this.props.width }, 'data-padding': this.getPadding(), 'data-displayed': !this.props.hidden },
      React.createElement(Label, { text: this.props.label }),
      React.createElement(
        'div',
        { className: 'Input-description TextInput-description' },
        this.props.description
      ),
      !this.props.multiline && React.createElement('input', { ref: this.input, type: 'text', className: 'Input-control TextInput-control', value: this.props.value,
        name: this.props.name, placeholder: this.props.placeholder, onChange: this.handleChange, onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus, onBlur: this.handleBlur, tabIndex: this.props.tabIndex,
        'aria-label': this.props.ariaLabel, 'aria-required': this.props.ariaRequired }),
      this.props.multiline && React.createElement('textarea', { ref: this.input, className: 'Input-control TextInput-control', value: this.props.value,
        name: this.props.name, placeholder: this.props.placeholder, onChange: this.handleChange, onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus, onBlur: this.handleBlur, tabIndex: this.props.tabIndex,
        'aria-label': this.props.ariaLabel, 'aria-required': this.props.ariaRequired })
    );
  };

  return TextInput;
}(Component);

export default TextInput;